import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import TableSkeleton from "../../../Utils/TableSkeleton";
import { getData, Postdata, PostdataWithoutToken } from "../../../API/GlobalApi";
import Notifier from "../../../Utils/notify";
import "../../../assets/css/StudentShortDetails.css";

const DiscountFeeApprovalTemplates = () => {
    const { uniqueId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const signature = queryParams.get("signature");
    const user_id = queryParams.get("user_id");

    const navigate = useNavigate();
    const [feePlanData, setFeePlanData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);



    const getFeePlanData = async () => {
        setLoading(true);
        try {
            if (!uniqueId) return;

            const params = new URLSearchParams();
            params.append("unique_id", uniqueId);
            if (signature) params.append("signature", signature);
            if (user_id) params.append("user_id", user_id);

            const finalUrl = `finance/academic-group-fee-discounts-by-unique-id/?${params.toString()}`;
            const res = await getData(finalUrl);
            console.log("resssss", res)
            if (!res?.data || !res.data.length) {
                setFeePlanData(null);
                return;
            }

            const data = res.data[0]; // First academic group

            const mappedData = {
                full_course_name: data.academic_group_name,
                academic_year: data.academic_year,
                total_students: data.total_students,
                total_discount_amount: data.total_discount_amount,
                fee_head_names: data.fee_heads.map(fh => fh.fee_head_name),
                created_by: data.fee_heads.flatMap(fh => fh.students || [])?.[0]?.created_by || "N/A",
                students: data.fee_heads.flatMap(fh =>
                    (fh.students && fh.students.length
                        ? fh.students
                        : Array(fh.student_count).fill({ student_name: "N/A", registration_number: "N/A", discount: 0 })
                    ).map((stu, index) => ({
                        student_name: stu.student_name,
                        discount_name: stu.discount_name,
                        registration_number: stu.registration_number || "N/A",
                        fee_head_name: fh.fee_head_name,
                        discount_amount: fh.total_discount_amount / fh.student_count,
                        discount: stu.discount || 0
                    }))
                )

            };

            setFeePlanData(mappedData);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFeePlanData();
    }, [uniqueId]);
    // First, group fee_schedules by fee_head_name



    const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

    if (loading)
        return (
            <div className="container">
                <div className="d-flex justify-content-center align-items-center vh-100 text-muted">
                    <TableSkeleton />
                </div>
            </div>
        );

    if (!feePlanData)
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 text-danger text-center impose-responsive-font">
                No fee plan details found for ID: {uniqueId}
            </div>
        );

    const {
        full_course_name,
        academic_year,
        total_students,
        total_amount_scheduled,
        created_at,
        due_date,
        course_mode,
        fee_schedules,
        status,
        created_by,
    } = feePlanData;





    const handleApproval = async () => {
        try {
            const url = `finance/verify-discount-otp/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;
            const payload = { unique_id: uniqueId };
            const response = await PostdataWithoutToken(url, payload);

            if (response.error || response.detail) {
                Notifier.error(response.error || response.detail);
                return;
            }

            navigate("/fee-approval-success", { state: { type: "discount" } });


        } catch (error) {
            console.error(error);
            Notifier.error("Something went wrong while approving the fee plan");
        }
    };

    const handleCancel = async () => {
        try {
            const url = `finance/reject-fee-discount-plan/?signature=${encodeURIComponent(
                signature
            )}&user_id=${encodeURIComponent(user_id)}`;
            const payload = { unique_id: uniqueId };
            const response = await PostdataWithoutToken(url, payload);
            if (response.error) {
                Notifier.error(response.error);
                return;
            }
            Notifier.success("Fee plan rejected successfully!");
            navigate("/fee-approval-cancel");
        } catch (error) {
            console.error(error);
            Notifier.error("Something went wrong while rejecting the fee plan");
        }
    };

    return (
        <div className="container py-4 impose-responsive-font">
            <h2 className="text-center mt-5 mb-4 impose-responsive-font templateFeeTitles">
                Fee Discount
            </h2>

            {/* Top Info */}
            {feePlanData && (
                <div className="row g-3 mb-4 mt-4 impose-responsive-font detailsContainer">
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Course:</strong>
                        <div>{feePlanData.full_course_name}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Admission Academic Year:</strong>
                        <div>{feePlanData.academic_year}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Created By:</strong>
                        <div>{feePlanData.created_by}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Total Student:</strong>
                        <div>{(feePlanData.total_students)}</div>
                    </div>

                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Discount  Amount:</strong>

                        <div>  ₹{Number(feePlanData?.students[0]?.discount).toFixed(2)}
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Total Discount Amount:</strong>
                        <div>₹{Number(feePlanData.total_discount_amount).toFixed(2)}</div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Fee Head(s):</strong>
                        <div>
                            {feePlanData.fee_head_names?.join(", ")}
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 contentDiv">
                        <strong>Discount Name:</strong>
                        <div>
                            {feePlanData?.students[0]?.discount_name}
                        </div>
                    </div>


                </div>
            )}

            {/* Accordion Header */}
            <div
                className="accordion-header d-flex justify-content-between align-items-center p-3 bg-light border rounded impose-accordion-header"
                style={{ cursor: "pointer" }}
                onClick={toggleAccordion}
            >
                <h5 className="mb-0 impose-responsive-font">Fee Details</h5>
                <span style={{ color: "#7F56DA", fontSize: "15px" }}>
                    {isAccordionOpen ? "▲" : "▼"}
                </span>
            </div>

            {/* Accordion Content */}
            {isAccordionOpen && feePlanData && (
                <div className="accordion-body mt-2">
                    <div
                        className="table-responsive impose-table"
                        style={{ maxHeight: "400px", overflowY: "auto" }}
                    >
                        <table className="table table-bordered text-center mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th className="text-start">Student Name</th>
                                    <th>Registration Number</th>
                                    <th className="text-end" >Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feePlanData.students.map((fh, index) => (

                                    <tr key={index}>

                                        <td>{index + 1}</td>
                                        <td className="text-start">{fh?.student_name || "N/A"}</td>
                                        <td>{fh?.registration_number || "N/A"}</td>
                                        <td className="text-end">₹{Number(fh.discount).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {/* Buttons (no change) */}
            <div className="row g-3 align-items-end impose-buttons mt-3">
                <div className="col-12 col-md-6"></div>
                <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center gap-2 btnContainers">
                    <button className="add-btn px-4" onClick={handleApproval}>
                        Approve
                    </button>
                    <button className="btn btn-secondary px-4" onClick={handleCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>

    );
};



export default DiscountFeeApprovalTemplates